<template>
  <div class="rcenter">
    <top-nav :show-user="true" />
    <div class="content-container" v-if="!currentView">
      <div class="row flex-row">
        <div class="col s12">
          <div class="section-title">
            <em>Act to Adapt </em> Resource Centre
          </div>
          <div class="description justify-text">
            <p>
              Welcome to the <em> Act to Adapt</em> Resource Centre! Here you
              will find a collection of helpful resources from reputable sources
              to support you in completing your Climate Change Home Risk
              Assessment and Adaptation Plan.
            </p>
            <p>
              The resources are organized by Wind Hazard, Flood Hazard, Water
              Shortage Hazard and Household Carbon Footprint. Each section
              includes resources to help you with your Assessment as well as
              your proposed projects/measures for home improvement – some
              resources serve a dual purpose.
            </p>
            <p>
              The resources provided here are just meant to be a starting point
              - there are more resources available on the Internet that you can
              access for support. As you look for additional resources, always
              make sure you take information from a reputable, trusted source
              and that the information can be applied to Saint Lucia’s context.
            </p>
            <p>
              If you cannot find what you are looking for in the Resource Centre
              or online, you can
              <router-link :to="{ name: 'askAnExpert' }"
                ><b>Ask an Expert</b></router-link
              >
              for help.
            </p>
          </div>
        </div>
        <div
          class="col s6 m4 flex-item"
          v-for="resource in resourcesX"
          :key="resource.id"
        >
          <div class="card hoverable">
            <div class="card-content">
              <div class="card-icon center-align">
                <router-link
                  :to="{ name: 'resource', params: { id: resource.id } }"
                >
                  <img width="95%" :src="resource.image" alt="" />
                </router-link>
              </div>
              <router-link
                :to="{ name: 'resource', params: { id: resource.id } }"
                class="card-title grey-text text-darken-3"
                v-html="resource.title"
              ></router-link>
            </div>
            <div class="card-action">
              <router-link
                style="width: 100%;"
                :to="{ name: 'resource', params: { id: resource.id } }"
                class="btn-small btn-rounded  indigo accent-2"
              >
                VIEW DETAILS
              </router-link>
            </div>
          </div>
        </div>

        <div class="col s12 m4 flex-item">
          <div class="card hoverable">
            <div class="card-content">
              <div class="card-icon center-align">
                <img :src="questionMarks" height="110px" alt="" />
              </div>
              <div class="card-title">
                Ask an Expert
              </div>
            </div>
            <div class="card-action">
              <router-link
                :to="{ name: 'askAnExpert' }"
                style="width: 100%;"
                class="btn-small btn-rounded  indigo accent-2"
              >
                VIEW DETAILS
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0 16px;"><router-view></router-view></div>
    <app-bottom-tab />
  </div>
</template>
<script>
import questionMarks from "@/assets/questionMark@2x.png";
import { mapState } from "vuex";
import { getResources } from "@/api/helpers.api.js";
import topNav from "@/components/topNav.vue";
import AppBottomTab from "@/components/AppBottomTab";
import energyIcon from "@/assets/energy_calculator.svg";
import waterPpl from "@/assets/water_shortage.svg";
import windHazard from "@/assets/wind-hazard@2x.png";
import floodHazard from "@/assets/flood-hazard@2x.png";
export default {
  name: "resourceCentre",
  props: {},
  data() {
    return {
      questionMarks,
      ready: false,
      //		fromApi: [],
    };
  },
  components: {
    topNav,
    AppBottomTab,
  },
  mounted() {
    this.$_getResources();
    this.resourcesX.length > 0 ? (this.ready = true) : false;
  },
  computed: {
    ...mapState({
      resources: (state) => state.Helpers.resources,
    }),
    currentView: {
      get() {
        return this.$route.name === "resource";
      },
    },
    resourcesX: {
      get() {
        function compare(a, b) {
          if (a.id < b.id) return -1;
          if (a.id > b.id) return 1;
          return 0;
        }
        return this.resources
          ? this.resources
              .map((x) => {
                return {
                  ...x.acf,
                  title: x.title.rendered,
                  id: x.id,
                  image:
                    x.id === 3075
                      ? windHazard
                      : x.id === 3082
                      ? floodHazard
                      : x.id === 3088
                      ? waterPpl
                      : energyIcon,
                };
              })
              .sort(compare)
          : [];
      },
    },
  },
  methods: {
    $_getResources() {
      getResources()
        .then((res) => {
          //	this.fromApi = res.data
          this.$store.commit("Helpers/SET_RESOURCES", res.data);
          setTimeout(() => {
            this.ready = true;
          }, 100);
        })
        .catch((err) => {
          return err;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.content-container {
  max-width: 690px;
  margin: auto;
  //	padding-bottom: 64px;
  padding: 0 16px 64px;
}
.section-title {
  font-size: 26px;
  margin: 16px 0px 2px;
  position: relative;
}
.card {
  .card-title {
    text-align: center;
    font-size: 15px;
    line-height: 18px;
  }
  border-radius: 6px;
  .card-content {
    padding-bottom: 0px;
  }
  .card-action {
    padding-top: 0px;
    border-radius: 0 0 6px 6px;
  }
}
.description {
  p {
    text-align: just;
  }
}
.flex-row {
  display: inline-flex;
  flex-wrap: wrap;
  .flex-item {
    margin: 0px;
    float: none;
    .card {
      height: calc(100% - 1.5rem);
    }
  }
}
</style>
